export default {
  demoMode: false, // when true, all values below will be imported where relevant
  demoShortPostedId: 1232247, // ** for 1&2 day: location: src > Components > Schedule > generateListPostedScheduleArray.js (lines 11 and 19)
  demoLongPostedId: 1231638,  // ** for 7&9 day: location: src > Components > Schedule > generateListPostedScheduleArray.js (lines 21 and 22)
  // below is a userId w/ a particularly long list of resourceCollecitonIds (live schedules) that they can view
  demoListOfResourceCollectionsUserId: 17610, // location: src > api > liveScheduleApi.js (line 18)
  // below is a resourceId w/ access to a lot of previous postings (posted schedules)
  demoPreviousPostingsResourceId: 5965,  // others: [5965, 25796] ** location: src > api > postedScheduleApi.js (line 71)
  demoDayTypeCalendarResourceId: 22598, //  ** location: src > api > dayTypeApi.js (line 26)
  demoDayTypeCalendarShowFutureDays: 2, //  ** location: src > api > dayTypeApi.js (line 29)
  demoDayTypeCalendarUserId: 21557 // (ensures days on calendar aren't blocked as 'BUSY') ** location: src > api > dayTypeApi.js (line 30, 40)
}





// WEBPACK FOOTER //
// ./src/__test__/demoParams.js